import { defineComponent, reactive, ref, watch } from "vue";
import { ProfilePageReq as ContractPageReq } from "@/views/contract/profile/profile.interface";
import { ProfileService as ContractService } from "@/views/contract/profile/profile.service";
import { columns } from "./contract-import-select.constant";

export default defineComponent({
  isGlobal: true,
  name: "ContractImportSelect",
  props: {
    value: {
      type: String,
      default: undefined,
    },

    projectId: {
      type: String,
      default: "",
    },

    needProjectId: {
      type: Boolean,
      default: true,
    },
    showDistinguish:{
      type:Boolean,
      default:false
    }
  },
  emits: ["update:value", "change"],
  setup(props, { emit }) {
    const visible = ref(false);
    const selectedKeys = ref<string[]>([]);
    const queryRef = reactive(new ContractPageReq()) as any;
    queryRef.contractStatusList = ["wsx,shz,lyz,lywb"];
    const { data: dataSource, loading, run, refresh, pagination } = ContractService.usePageApi();

    const showModal = () => {
      if (props.needProjectId && !props.projectId) {
        return;
      }
      visible.value = true;
    };

    const closeModal = () => {
      visible.value = false;
    };

    const ok = () => {
      if (selectedKeys.value.length) {
        emit("update:value", selectedKeys.value[0]);
        emit("change", selectedKeys.value[0]);
      }
      closeModal();
    };

    const search = async () => {
      selectedKeys.value = [];
      queryRef.current = 1;
      queryRef.projectId = props.projectId;
      if (props.showDistinguish) {
        queryRef.distinguish = "gcht";
      }
      await run(queryRef);
    };

    const onTableChange = async (pagination) => {
      queryRef.current = pagination.current;
      queryRef.size = pagination.pageSize;
      if (props.showDistinguish) {
        queryRef.distinguish = "gcht";
      }
      await run(queryRef);
    };

    const onSelectionChange = (keys: string[]) => {
      selectedKeys.value = keys;
    };

    const removeSelected = () => {
      emit("update:value", undefined);
    };

    watch(
      () => props.projectId,
      async () => {
        if (props.needProjectId && !props.projectId) {
          return;
        }
        await search();
      },
      { immediate: true }
    );

    return {
      visible,
      showModal,
      closeModal,
      ok,
      selectedKeys,
      queryRef,
      loading,
      dataSource,
      columns,
      pagination,
      refresh,
      search,
      onTableChange,
      onSelectionChange,
      removeSelected,
    };
  },
});
